import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  top: 20px;
  right: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: 768px) {
    bottom: 16px;
    right: 16px;
  }
`
